export default __webpack_public_path__ + "static/media/the wave.0e5c70dd.jpg";